/**
 * The modifier family of a KeyboardEvent.code: "ctrl" / "alt" / "shift", or null for an ordinary key
 * (exactly these three are the layer modifiers; Meta is deliberately not one). Pure keycode semantics
 * with no dependencies of its own, so it lives on the hardware (keycode) side; the resolver
 * (profile-resolver/project), the modifier hook (modifiers/use-modifiers), the geometry helpers, and
 * the render surfaces all share this one definition instead of hand-keeping copies in sync.
 */
export function modifierFamily(code: string): "ctrl" | "alt" | "shift" | null {
  if (code.startsWith("Control")) return "ctrl";
  if (code.startsWith("Alt")) return "alt";
  if (code.startsWith("Shift")) return "shift";
  return null;
}
